import { push } from 'connected-react-router'
import { API_URL, SERVER_ERROR } from '../settings'
import Cookies from 'universal-cookie'
import helpers from '../helpers'
import store from '../store'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import fetch from 'isomorphic-fetch'

export const APPEAL_LOGOUT = '/appeals/APPEAL_LOGOUT'
export const APPEAL_LOADED = '/appeals/APPEALS_LOADED'
export const APPEAL_NOT_LOADED = '/appeals/APPEALS_NOT_LOADED'
export const REGISTER_SUCCESS = '/appeals/REGISTER_SUCCESS'
export const REGISTER_FAIL = '/appeals/REGISTER_FAIL'
export const REGISTER_PENDING = '/appeals/REGISTER_PENDING'
export const UPDATE_SUCCESS = '/appeals/UPDATE_SUCCESS'
export const UPDATE_PENDING = '/appeals/UPDATE_PENDING'
export const UPDATE_FAIL = '/appeals/UPDATE_FAIL'
export const LOGIN_SUCCESS = '/appeals/LOGIN_SUCCESS'
export const LOGIN_PENDING = '/appeals/LOGIN_PENDING'
export const LOGIN_FAIL = '/appeals/LOGIN_FAIL'
export const FILE_UPLOAD_SUCCESS = '/appeals/FILE_UPLOAD_SUCCESS'
export const FILE_UPLOAD_PENDING = '/appeals/FILE_UPLOAD_PENDING'
export const FILE_UPLOAD_FAIL = '/appeals/FILE_UPLOAD_FAIL'
export const DANDS_SUCCESS = '/appeals/DANDS_SUCCESS'
export const DANDS_PENDING = '/appeals/DANDS_PENDING'
export const DANDS_FAIL = '/appeals/DANDS_FAIL'
export const CREATE_REPLY_SUCCESS = '/appeals/CREATE_REPLY_SUCCESS'
export const CREATE_REPLY_PENDING = '/appeals/CREATE_REPLY_PENDING'
export const NEW_TOKEN = '/appeals/NEW_TOKEN'
export const GET_REASONS_SUCCESS = '/appeals/GET_REASONS_SUCCESS'
export const GET_REASONS_PENDING = '/appeals/GET_REASONS_PENDING'
export const GET_REASONS_FAIL = '/appeals/GET_REASONS_FAIL'

var moment = require('moment')

const cookies = new Cookies()

export const register = (e) => (dispatch) => {
  const data = {
    pcn: helpers.formatPCN(e.target.pcn.value),
    reg: helpers.formatReg(e.target.reg.value),
    email: helpers.formatEmail(e.target.email.value),
    date: e.target.date.value,
    status: 'registering',
    submitby: moment(e.target.date.value, 'YYYY-MM-DD').add(21, 'days')

  }

  dispatch({
    type: REGISTER_PENDING,
    data
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/appeals/register`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: REGISTER_SUCCESS
          })
          dispatch(push('/confirm-email'))
          return
        }

        dispatch({
          type: REGISTER_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log(error)
      dispatch({
        type: REGISTER_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const login = (e) => (dispatch) => {
  const data = {
    pcn: helpers.formatPCN(e.target.pcn.value),
    email: helpers.formatEmail(e.target.email.value)
  }

  dispatch({
    type: LOGIN_PENDING,
    data
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/appeals/login`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: LOGIN_SUCCESS
          })

          dispatch(push('/login-email'))
          return
        }

        dispatch({
          type: LOGIN_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log(error)
      dispatch({
        type: LOGIN_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const loadAppeal = (appealID) => (dispatch) => {
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }

  fetch(`${API_URL}/appeals/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          cookies.set('appealID', appealID, { path: '/' })
          dispatch({
            type: APPEAL_LOADED,
            data: res.item
          })

          dispatch({
            type: NEW_TOKEN,
            data: res.token
          }, (
            dispatch(getReasons(res.token))
          ))

          if (res.status === 'registering') {
            dispatch(setStatusQuiet(appealID, 'registered'))
            dispatch(addActivity(appealID, `Appellant logged in for the first time successfully.`))
          }

          // dispatch(addActivity(appealID, `Appellant logged in successfully.`))

          return
        }

        dispatch({
          type: APPEAL_NOT_LOADED,
          error: res.error
        })
        toastPush(res.error, 'error')

        cookies.remove('appealID', { path: '/' })
        dispatch(push('/'))
      })
    }, () => {
      dispatch({
        type: APPEAL_NOT_LOADED,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
      dispatch(push('/'))
    }

    )
}

export const logOut = (e) => {
  const expired = moment(store.getState().appeal.data.submitby).add(1, 'days').isBefore(moment(new Date(), 'day'))
  const submitted = store.getState().appeal.data.submittedDate
  const appealID = store.getState().appeal.data.appealID
  let r = true

  if (!expired && !submitted) {
    r = window.confirm('You have not yet declared and submitted your appeal, are you sure you want to log out?')
  }

  if (r === true) {
    return dispatch => {
      cookies.remove('appealID', { path: '/' })
      dispatch({
        type: APPEAL_LOGOUT
      })
      dispatch(addActivity(appealID, `Appellant logged out.`))

      dispatch(push('/'))
    }
  }

  return dispatch => {

  }
}

const tokenLogout = (msg) => (dispatch) => {
  cookies.remove('appealID', { path: '/' })
  dispatch({
    type: APPEAL_LOGOUT
  })
  toastPush('Your session token is invalid or has expired, please login again. Error: ' + msg, 'error')
  dispatch(push('/'))
}

export const saveForm = (e) => (dispatch) => {
  let f = e.target
  const id = e.target.id
  dispatch({
    type: UPDATE_PENDING,
    id
  })

  let data = {}
  // Extract Each Element Value
  for (var i = 0; i < f.elements.length; i++) {
    if (f.elements[i].name) {
      if (f.elements[i].value.length > 0) {
        if (f.elements[i].type === 'radio') {
          if (f.elements[i].checked) {
            data[f.elements[i].name] = f.elements[i].value
          }
        } else {
          if (f.elements[i].value) {
            data[f.elements[i].name] = f.elements[i].value
          }
        }
      }
    }
  }

  var merged = {
    ...store.getState().appeal.data,
    ...data
  }

  // format reg
  merged.reg = helpers.formatReg(merged.reg)

  switch (id) {
    case 'details':
      merged.completed_driver_details = true
      merged.status = 'writing'
      break
    case 'grounds':
      merged.completed_appeal_grounds = true
      merged.status = 'writing'
      break
    case 'appealDetail':
      merged.completed_appeal_detail = true
      merged.status = 'writing'
      break

    default:
      break
  }

  if (merged.date) {
    merged.submitby = moment(merged.date, 'YYYY-MM-DD').add(21, 'days')
  }

  delete merged.uuid

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(merged)
  }

  fetch(`${API_URL}/appeals`, fetchOptions)
    .then((response) => {
      console.log(response)
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: UPDATE_SUCCESS,
            data: merged,
            id
          })
          dispatch(addActivity(merged.appealID, `Appellant updated appeal content`))

          toastPush('Saved', 'success')

          return
        }

        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }

        dispatch({
          type: UPDATE_FAIL,
          error: res.error,
          id
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log(error)
      dispatch({
        type: UPDATE_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const toastPush = (msg, type = 'success') => {
  if (type === 'error') {
    toast.error(msg, { autoClose: 3000, hideProgressBar: true })
  } else {
    toast.success(msg, { autoClose: 3000, hideProgressBar: true })
  }
}

export const declareAndSubmit = (e) => (dispatch) => {
  dispatch({
    type: DANDS_PENDING
  })

  var merged = {
    ...store.getState().appeal.data
  }

  const appealID = merged.appealID

  merged.submittedDate = moment(new Date())
  merged.status = 'submitted'
  console.log(merged)

  delete merged.uuid

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(merged)
  }

  console.log(fetchOptions)

  fetch(`${API_URL}/appeals`, fetchOptions)
    .then((response) => {
      console.log(response)
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: DANDS_SUCCESS,
            data: merged
          })

          toastPush('Submitted successfully', 'success')
          dispatch(setStatusQuiet(appealID, 'submitted'))
          dispatch(addActivity(appealID, `Appellant declared and submitted`))

          return
        }

        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }

        dispatch({
          type: DANDS_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log(error)
      dispatch({
        type: DANDS_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const createReply = (e, file = null) => (dispatch) => {
  dispatch({
    type: CREATE_REPLY_PENDING
  })
  const appealID = store.getState().appeal.data.appealID
  const appellant = store.getState().appeal.data.fname ? `${store.getState().appeal.data.fname} ${store.getState().appeal.data.lname}` : `Appellant`

  let data = {
    user: 'appellant',
    appellant
  }

  if (file && ['image/png', 'image/jpeg', 'image/gif'].includes(file.mime)) {
    data.reply = `Image uploaded:<br /> <a target='_blank' href='${file.url}'><img class='img-fluid' src='${file.url}' /></a>`
  }

  if (file && !['image/png', 'image/jpeg', 'image/gif'].includes(file.mime)) {
    data.reply = `Document uploaded:<br /> <a target='_blank' href='${file.url}'>${file.name}</a>`
  }

  if (!file) {
    data.reply = e.target.reply.value
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/replies/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: CREATE_REPLY_SUCCESS,
            reply: res.data
          })
          if (file) {
            toastPush('File uploaded', 'success')
            dispatch(addActivity(appealID, `Appellant uploaded a file`))
          } else {
            toastPush('Message sent', 'success')
            dispatch(addActivity(appealID, `Appellant sent a message`))
            document.getElementById('reply').reset()
          }
          dispatch(setStatusQuiet(appealID, 'pending adjudicator reply'))

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }
        // Response not OK
        dispatch({
          type: UPDATE_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      }, () => {
        dispatch({
          type: UPDATE_FAIL,
          error: SERVER_ERROR
        })
        toastPush(SERVER_ERROR, 'error')
      })
    },
    // Server Error
    () => {
      dispatch({
        type: UPDATE_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    })
}

export const setStatusQuiet = (appealID, status) => (dispatch) => {
  let data = { status }

  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/status/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch(loadAppeal(appealID))
          dispatch(addActivity(appealID, `Status changed to: ${data.status}`))
        }
      })
    }
    )
}

export const addActivity = (appealID, activity, url = null) => (dispatch) => {
  let data = {
    activity,
    url
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/activity/${appealID}`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          // dispatch(getAppeal(appealID))
          console.log(res)
        }

        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }
      })
    }
    )
}

export const fileUploadFinish = (file, s3url, appealID) => (dispatch) => {
  const data = {
    name: file.name,
    url: s3url,
    size: file.size,
    type: 'appellant'
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/uploadFinish/${appealID}`, fetchOptions)
    .then((response) => {
      console.log(response)
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: FILE_UPLOAD_SUCCESS
          })
          dispatch(addActivity(appealID, `Appellant uploaded file: ${data.name}`))
          toastPush('Uploaded', 'success')
          dispatch(loadAppeal(appealID))
          return
        }

        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }

        dispatch({
          type: FILE_UPLOAD_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log('response bad')
      console.log(error)
      dispatch({
        type: FILE_UPLOAD_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

export const fileUploadFinishChat = (file, s3url, appealID) => (dispatch) => {
  console.log(file)
  const data = {
    name: file.name,
    url: s3url,
    size: file.size,
    type: 'appellant',
    mime: file.type
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': store.getState().appeal.token
    },
    body: JSON.stringify(data)
  }

  fetch(`${API_URL}/uploadFinish/${appealID}`, fetchOptions)
    .then((response) => {
      console.log(response)
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: FILE_UPLOAD_SUCCESS
          })
          dispatch(addActivity(appealID, `Appellant uploaded file: ${data.name}`))
          dispatch(createReply(null, data))
          dispatch(loadAppeal(appealID))
          return
        }

        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }

        dispatch({
          type: FILE_UPLOAD_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, (error) => {
      console.log('response bad')
      console.log(error)
      dispatch({
        type: FILE_UPLOAD_FAIL,
        error: SERVER_ERROR
      })
      toastPush(SERVER_ERROR, 'error')
    }

    )
}

const getReasons = (token) => (dispatch) => {
  dispatch({
    type: GET_REASONS_PENDING
  })
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    }
  }

  fetch(`${API_URL}/reasons`, fetchOptions)
    .then((response) => {
      response.json().then((res) => {
        if (response.ok) {
          dispatch({
            type: GET_REASONS_SUCCESS,
            data: res
          })

          return
        }
        if (res.auth === false) {
          dispatch(tokenLogout(res.message))
        }
        dispatch({
          type: GET_REASONS_FAIL,
          error: res.error
        })
        toastPush(res.error, 'error')
      })
    }, () => {
      dispatch({
        type: GET_REASONS_FAIL,
        error: SERVER_ERROR
      })
    }

    )
}



// WEBPACK FOOTER //
// ./src/actions/appealActions.js